// Shared socket.io client for defect chat live push.
//
// One app-wide connection, created lazily on first use and reused everywhere
// (chat modal rooms + the top-bar activity badge). Auth mirrors the REST
// layer: username + bToken from localStorage go in the handshake and the
// server validates them against user.user_token. socket.io reconnects itself
// and falls back to HTTP long-polling if the proxy blocks websocket upgrades;
// every consumer keeps a REST/polling path, so a dead socket only costs
// immediacy, never correctness. Logout does a full localStorage.clear() +
// redirect, which tears the page (and this socket) down with it.

import { io } from 'socket.io-client';
import { baseUrl } from '../../shared';

const socketUrl = baseUrl.replace(/\/api\/?$/, '');

let socket = null;

export function getDefectSocket() {
  if (typeof window === 'undefined') return null;
  const username = localStorage.getItem('username');
  const bToken = localStorage.getItem('bToken');
  if (!username || !bToken) return null;
  if (!socket) {
    socket = io(socketUrl, {
      auth: { username, bToken },
    });
    socket.on('connect_error', () => {
      // Expected when offline or the socket path is blocked; consumers poll anyway.
    });
  }
  return socket;
}
